import {
  Baby,
  BookOpen,
  CalendarDays,
  Church,
  Flame,
  Globe,
  GraduationCap,
  HandHeart,
  Handshake,
  Heart,
  HeartHandshake,
  Home,
  Megaphone,
  Music,
  Palette,
  ShieldCheck,
  Sparkles,
  Speaker,
  Users,
  Video,
  type LucideIcon,
} from 'lucide-react';

/**
 * O emblema de cada coordenação, e o único lugar que traduz o slug guardado em
 * `coordinations.icon` para um componente.
 *
 * **Por que um catálogo fechado, e não o nome do ícone direto do banco.** A
 * alternativa óbvia é gravar `"Baby"` e resolver por `lucide[nome]` — ela custa
 * o bundle inteiro da lucide (mil e poucos ícones) numa SPA que 150 voluntários
 * abrem no 4G da igreja, e amarra o cadastro da secretaria à nomenclatura em
 * inglês de uma biblioteca. Aqui o import é estático, o bundler leva só estes
 * vinte, e o slug é em português, sobre o que a coordenação FAZ — se a lucide
 * for trocada um dia, muda este arquivo e nenhuma linha do banco.
 *
 * **O banco não valida o slug** (ver a migration `coordination_icon`): é a
 * regra 12 que decide isso — com CHECK, cada ícone novo do catálogo viraria
 * migration. O preço é que este arquivo precisa aguentar valor desconhecido,
 * e é o que `resolveOrgIcon` faz.
 */
const ORG_ICONS: Record<string, LucideIcon> = {
  'acao-social': HeartHandshake,
  artes: Palette,
  casais: Heart,
  comunicacao: Megaphone,
  cuidado: HandHeart,
  discipulado: BookOpen,
  ensino: GraduationCap,
  eventos: CalendarDays,
  familia: Home,
  igreja: Church,
  jovens: Sparkles,
  kids: Baby,
  louvor: Music,
  midia: Video,
  missoes: Globe,
  oracao: Flame,
  pessoas: Users,
  producao: Speaker,
  seguranca: ShieldCheck,
  voluntariado: Handshake,
};

/**
 * O ícone neutro. Ele existe para os dois casos que a coluna anulável cria e
 * que são estado legítimo, não erro: coordenação cadastrada antes desta coluna
 * e slug que não está (ou não está mais) no catálogo.
 *
 * Card sem ícone não é opção — a faixa do topo ficaria vazia em alguns cards e
 * cheia em outros, e a grade passaria a parecer meio carregada.
 */
const FALLBACK_ICON: LucideIcon = Church;

/** Nunca devolve `undefined`: slug desconhecido cai no emblema neutro. */
export function resolveOrgIcon(slug: string | null | undefined): LucideIcon {
  if (!slug) return FALLBACK_ICON;
  return ORG_ICONS[slug] ?? FALLBACK_ICON;
}

/** Os slugs válidos, para quem cadastra pelo script de admin. */
export const ORG_ICON_SLUGS = Object.keys(ORG_ICONS);
